import { render, staticRenderFns } from "./placeholder.vue?vue&type=template&id=f516382e&scoped=true&"
import script from "./placeholder.vue?vue&type=script&lang=js&"
export * from "./placeholder.vue?vue&type=script&lang=js&"
import style0 from "./placeholder.vue?vue&type=style&index=0&id=f516382e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f516382e",
  null
  
)

export default component.exports